import {
  FETCH_NOTIFICATIONS_START,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  SET_FETCH_NOTIFICATION_PAGINATION,
  RESET_NOTIFICATION_DATA,
  FETCH_NOTIFICATION_BELL_COUNT_SUCCESS
} from "../actions/ActionConstant";

const initialState = {
  notification: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
    pagination: {
      page: 1,
      per_page: 25,
    }
  },
  notifications: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
  },
  bellCount: 0
};

const NotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_START:
      return {
        ...state,
        notification: {
          ...state.notification,
          loading: true,
          error: false,
          inputData: action.data,
        },
      };
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notification: {
          ...state.notification,
          data: {
            ...action.data,
            data: state.notification.data?.data
              ?
              [
                ...state.notification.data.data.filter(
                  item => !action.data.data.some(newItem => newItem.id === item.id)
                ),
                ...action.data.data,
              ]
              : action.data.data,
          },
          loading: false,
          error: false,
          inputData: {},
        },
      };
    case FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        notification: {
          ...state.notification,
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
        },
      };
    case SET_FETCH_NOTIFICATION_PAGINATION:
      return {
        ...state,
        notification: {
          ...state.notification,
          pagination: {
            ...state.notification.pagination,
            page: action.data.page
          } 
        }
      }
    case RESET_NOTIFICATION_DATA:
      return {
        ...state,
        notification: {
          ...state.notification,
          data: {},
          pagination: {
            ...state.notification.pagination,
            page: 1
          } 
        }
      }
    case FETCH_NOTIFICATION_BELL_COUNT_SUCCESS:
      return {
        ...state,
        bellCount: action.data.count
      }
    default:
      return state;
  }
};

export default NotificationReducer;
